import { cn } from "@/lib/utils";
import type { LogoProps } from "@/types/ui";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import * as styles from "./Logo.styles";

const Logo = ({ onClick }: LogoProps) => {
  const { t } = useTranslation("common");

  return (
    <NavLink to="/dashboard" onClick={onClick} className={styles.logoLink} aria-label={t("app.logo")}>
      <svg className={cn(styles.logoIcon, "animate-fade-in")} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
          <linearGradient id="logo-g" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#8B5CF6" />
          </linearGradient>
        </defs>
        <rect width="32" height="32" rx="7" fill="url(#logo-g)" />
        <rect x="10" y="6.5" width="3.5" height="19" rx="1.75" fill="white" />
        <path d="M13.5 6.5 h5 a4.5 4.5 0 0 1 0 9 h-5 z" fill="white" />
        <circle cx="24.5" cy="24.5" r="2.5" fill="#FBBF24" />
      </svg>
      <h1 className={styles.logo}>{t("app.logo")}</h1>
    </NavLink>
  );
};

export { Logo };
